export enum AppMutation {
    SET_IS_LOADING = 'APP_SET_IS_LOADING_MUTATION',
    ADD_NOTIFICATION = 'APP_ADD_NOTIFICATION_MUTATION',
    REMOVE_NOTIFICATION = 'APP_REMOVE_NOTIFICATION_MUTATION',
}